import React from "react";
import LoadingOverlay from "../LoadingOverlay";

const DEMO_DURATION_MS = 2000;

const DevToolsSidebarLoadingDemo: React.FC = () => {
    const [loading, setLoading] = React.useState(false);
    const timerRef = React.useRef<number | undefined>(undefined);

    // Clear any pending auto-reset if the demo is closed mid-run, so it never sets state after unmount.
    React.useEffect(() => () => window.clearTimeout(timerRef.current), []);

    const showOverlay = () => {
        window.clearTimeout(timerRef.current);
        setLoading(true);
        timerRef.current = window.setTimeout(() => setLoading(false), DEMO_DURATION_MS);
    };

    return (
        <div className="p-4">
            <button
                type="button"
                className="rounded bg-slate-700 px-3 py-1.5 text-sm text-white disabled:opacity-50"
                onClick={showOverlay}
                disabled={loading}
            >
                Show Loading Overlay
            </button>
            <LoadingOverlay show={loading} text="Loading Dev Tools Sidebar..." />
        </div>
    );
};

export default DevToolsSidebarLoadingDemo;
